var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "event-form"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveEvent.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.signEventDates, function (month, index) {
    return _c('div', {
      key: index,
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "podnikamOd"
      }
    }, [_vm._v("Termín podpisu")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: month.date,
        expression: "month.date"
      }],
      staticClass: "text-input w-input date-input",
      attrs: {
        "type": "datetime-local",
        "min": _vm.todayLong,
        "maxlength": "256",
        "name": "podnikamOd",
        "data-name": "podnikamOd",
        "id": "podnikamOd",
        "required": ""
      },
      domProps: {
        "value": month.date
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(month, "date", $event.target.value);
        }
      }
    })]);
  }), _c('sidlo-input', {
    attrs: {
      "type": 'house',
      "not-required": {
        supisne: true
      },
      "not-included": {
        orientacne: true
      }
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event);
      }
    }
  }), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "sprava"
    }
  }, [_vm._v("Správa pre klienta")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.invitationForm.description,
      expression: "invitationForm.description"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "id": "sprava"
    },
    domProps: {
      "value": _vm.invitationForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.invitationForm, "description", $event.target.value);
      }
    }
  })])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }